var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-session h-screen flex flex-col items-center justify-center px-6"},[(_vm.error)?[_c('p',{staticClass:"text-danger text-center mb-4"},[_vm._v(_vm._s(_vm.error))]),_c('vs-button',{on:{"click":_vm.consume}},[_vm._v("Retry")])]:[_c('p',{staticClass:"text-center"},[_vm._v("Connecting to fleet tracking…")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }